module.exports = __webpack_public_path__ + "img/mail_bind_2.649e7d2c.png";